import { planChunks } from '@clodo/api';

class Uploader{
    constructor() {
        this.files = [];
        this.tempFiles = [];
        this.totalTempFiles = 0;
        this.processedTempFiles = 0;
        this.handleFileInfo = null;
        this.handleHistorical = null;
        this.itemsManipulator = null;
        this.inProgress = false;
        this.chunkSize = 1024 * 1024 * 200; // 200MB chunks
    }

    splitFile(file){
        const tempFile = this.fileExist({name : file.name+".tmp", path : file.path, currentPath : file.currentPath})
        const plan = planChunks(file.size, tempFile ? tempFile.size : 0, this.chunkSize);
        file.totalChunks = plan[plan.length - 1].totalChunks;
        plan.forEach(({offset, length, chunkIndex, totalChunks}) => {
            const chunk = file.slice(offset, offset + length);
            chunk.chunkIndex = chunkIndex;
            chunk.chunkOffset = offset;
            chunk.path = file.path;
            chunk.currentPath = file.currentPath;
            chunk.name = file.name+".part"+chunkIndex;
            chunk.totalChunks = totalChunks;
            chunk.initialSize = file.size;
            chunk.existing = file.existing;
            this.tempFiles.push(chunk);
        });
    }

    fileExist(file){
        let fileFolder = this.itemsManipulator.elements;
        const fullPath = [];
        fullPath.push(...file.currentPath,...file.path);
        fullPath.every( folderName => {
            fileFolder = fileFolder.child.find( element => element.name === folderName && element.type === 'folder');
            return fileFolder;
        });
        if(fileFolder){
            return fileFolder.child.find( element => element.name === file.name && element.type === 'file')
        }
        return false;
    }

    scanFiles(item,currentPath,path) {
        if (item.isFile) {
            item.file(file => {
                this.processFiles(file,path,currentPath);
                this.checkFiles();
            });
        }
        if (item.isDirectory) {
            let newPath = Array.from(path);
            newPath.push(item.name);
            let directoryReader = item.createReader();
            let uploader = this;
            directoryReader.readEntries(function(entries) {
                uploader.totalTempFiles += entries.length;
                entries.forEach(function(entry) {
                    uploader.scanFiles(entry,currentPath,newPath);
                });
                uploader.totalTempFiles--;
                uploader.checkFiles();
            });
        }
    }

    processFiles(file,path,currentPath){
        file.path = path;
        file.currentPath = currentPath;
        file.existing = this.fileExist(file);
        file.chunkIndex = 0;
        file.chunkOffset = 0;
        file.totalChunks = 0;
        if(file.size > this.chunkSize) {
            this.splitFile(file);
        } else {
            this.tempFiles.push(file);
        }
        this.processedTempFiles++;
    }
    
    dropFiles(event,currentPath){
        event.preventDefault();

        let items = event.dataTransfer.items;
        this.totalTempFiles = items.length;
    
        for (let i=0; i<items.length; i++) {
            let item = items[i].webkitGetAsEntry();
    
            if(item) {
                this.scanFiles(item,currentPath,[]);
            }
        }
        this.checkFiles();
    }

    addUploadFiles(fileList,currentPath=[],path=[]){
        this.totalTempFiles = [...fileList].length;
        [...fileList].forEach( file => {
            this.processFiles(file,path,currentPath);
        });
        this.checkFiles();
    }

    checkFiles(){
        if(this.processedTempFiles === this.totalTempFiles) {
            this.processedTempFiles = 0;
            const existingFiles = this.tempFiles.filter((file) => file.existing);

            if(existingFiles.length > 0 && !window.confirm(existingFiles.length + " files already exist overright ?")) {
                this.files.push(...this.tempFiles.filter((file) => file.existing === false));
            } else {
                this.files.push(...this.tempFiles);
            }
            
            this.tempFiles = [];

            if(!this.inProgress && this.files.length > 0) {
                this.uploadFile();
            }
        }
    }

    uploadFile(force){
        this.inProgress = true;
        let file = this.files.shift();
        let xhr = new XMLHttpRequest(); //creating new xhr object (AJAX)
        let fileSize;
        xhr.open("POST", this.itemsManipulator.api.apiUrl);
        xhr.upload.addEventListener("progress", ({loaded, total}) =>{ //file uploading progress event
            if(file.totalChunks > 0 ){
                // L'offset du chunk donne l'avancement exact, y compris sur une
                // reprise qui ne repart pas de zéro.
                total = file.initialSize;
                loaded = file.chunkOffset + loaded;
            }
            let fileLoaded = Math.floor((loaded / total) * 100);  //getting percentage of loaded file size
            let fileTotal = Math.floor(total / 1000); //gettting total file size in KB from bytes
            // if file size is less than 1024 then add only KB else convert this KB into MB
            (fileTotal < 1024) ? fileSize = fileTotal + " KB" : fileSize = (loaded / (1024*1024)).toFixed(2) + " MB";
            this.handleFileInfo({'name': file.name, 'size' : fileSize, 'loaded' : fileLoaded});
        });
        const uploader = this;
        xhr.addEventListener("error", event => {
            alert("Error during transfert of "+file.name);
            uploader.handleFileInfo({'name': file.name, 'size' : fileSize, 'loaded' : 100});
        });
        const itemsManipulator = this.itemsManipulator;
        xhr.onload = function(event) {
            if (xhr.status !== 200) {
                uploader.handleFileInfo({'name': file.name, 'size' : fileSize, 'loaded' : 100});
                return;
            }
            if(file.totalChunks === 0 || file.chunkIndex === file.totalChunks - 1){
                uploader.handleFileInfo({'name': file.name, 'size' : fileSize, 'loaded' : 100});
            }
            try {
                // Même routage de statut que le reste de l'app : parse() lève sur
                // un refus ("file_exist", "offset_mismatch") ou une session morte.
                const data = itemsManipulator.api.parse(xhr.responseText);
                uploader.handleHistorical(file.name + " : Uploaded!");
                itemsManipulator.handleContent(data.content,file.currentPath);
                itemsManipulator.handleCurrentPath(file.currentPath);
            } catch (error) {
                uploader.handleHistorical(file.name + " : Failed! " + error.message);
            }
            if(uploader.files.length > 0){
                uploader.uploadFile();
            }
            else{
                uploader.inProgress = false;
            }
        }

        // Le formulaire est construit par @clodo/api : source unique de vérité
        // des champs attendus par Element::uploadFile, partagée avec le mobile.
        // Seul le transport diffère ici — XHR, pour les événements de progression
        // que fetch ne fournit pas.
        xhr.send(itemsManipulator.api.buildUploadForm(file, {
            filename : file.name,
            path : file.path,
            currentPath : file.currentPath,
            chunkIndex : file.chunkIndex,
            chunkOffset : file.chunkOffset,
            totalChunks : file.totalChunks
        }));
    }
}

export default Uploader